import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME, COLOR } from "utils/constant";
import { GrideDateFormatter } from "ui/Date";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import { t } from "i18next";
import CellPopover from "ui/grid/DescriptionCell";
import { formatNorwegianNumber } from "utils/helper";
import { calculateFieldStats } from "utils/statUtils";

export const landingNoteJournalListGridColumns = () => {
	const gridItems: GridColumnProps[] = [
		{
			field: "noteNumber",
			title: t("LandingNoteNumber"),
			width: "200px",
			headerClassName: "no-border",
		},

		{
			field: "noteVersion",
			title: t("Version"),
			width: "80px",
			headerClassName: CLASSNAME.TableNumeric + " no-border",
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "registrationId",
			title: t("RegistrationIdShort"),
			width: "140px",
			headerClassName: " no-border",
		},

		{
			field: "packageId",
			title: t("Package"),
			headerClassName: "no-border",
			width: 90,
		},

		{
			field: "vesselRegistrationId",
			title: t("VesselRegistrationId"),
			width: 120,
		},
		{
			field: "vesselName",
			title: t("VesselName"),
			width: 200,

			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "registrationTime",
			title: t("RegistrationDateShort"),
			width: "110px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.registrationTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "lastCatchDate",
			title: t("LastCatchDate"),
			width: "150px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.lastCatchDate}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},

		{
			field: "catchField",
			title: t("Zone"),
			width: "120px",
			headerClassName: "no-border",
		},
		{
			field: "catchFieldName",

			title: t("CatchArea"),
			width: "300px",
			headerClassName: "no-border",
			cells: {
				data: (props) => <CellPopover {...props} />,
				groupFooter: (props) => {
					return <td {...props.tdProps}>{t("Total")}</td>;
				},
			},
		},

		{
			field: "fishingGearName",
			title: t("FishingGear"),
			width: "150px",
			headerClassName: "no-border",

			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},

		{
			field: "numberOfLines",
			title: t("NumberOfLines"),
			width: "100px",
			cells: {
				data: (props) => <NumericalCell {...props} formatDecimal={0} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},

		{
			field: "netLiveWeightKg",
			title: t("TotalWeight"),
			width: "150px",
			cells: {
				data: (props) => <NumericalCell {...props} />,
				headerCell: (props) => <NumericalHeader {...props} />,

				groupFooter: (props) => {
					const minDecimal = 2;
					const maxDecimal = 2;

					let data = props.dataItem.aggregates[props.field as any];

					return (
						<td className={CLASSNAME.TableNumeric}>
							<div style={{ marginTop: "20px" }} className="no-border td-bold">
								{formatNorwegianNumber(data.sum, minDecimal, maxDecimal)}
							</div>
						</td>
					);
				},
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			// headerCell: (props) => <NumericalHeader {...props} />,
		},
		{
			field: "roundWeightKg",
			title: t("RoundWeight"),
			width: "150px",
			cells: {
				data: (props) => <NumericalCell {...props} />,
				headerCell: (props) => <NumericalHeader {...props} />,
				groupFooter: (props) => {
					const minDecimal = 2;
					const maxDecimal = 2;

					let data = props.dataItem.aggregates[props.field as any];

					return (
						<td className={CLASSNAME.TableNumeric}>
							<div style={{ marginTop: "20px" }} className="no-border td-bold">
								{formatNorwegianNumber(data.sum, minDecimal, maxDecimal)}
							</div>
						</td>
					);
				},
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			// headerCell: (props) => <NumericalHeader {...props} />,
		},
		{
			field: "",
			width: "30",
		},
	];
	return gridItems;
};
